(function() {
  'use strict';
  
  // Prevent multiple initializations
  if (window.CardProductInteractionsInitialized) {
    return;
  }
  window.CardProductInteractionsInitialized = true;

  class CardProductInteractions {
    constructor(element) {
      this.element = element;
      this.init();
    }

    init() {
      // Find all card buttons (subscribe and one-time buy buttons)
      const subscribeButtons = this.element.querySelectorAll('.subscribe-btn');
      const oneTimeButtons = this.element.querySelectorAll('.one-time-btn');
      const backButtons = this.element.querySelectorAll('.button-back');

      // Add event listeners to subscribe buttons
      subscribeButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          this.showCardContent(button);
        });
      });

      // Add event listeners to one-time buy buttons
      oneTimeButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          this.showCardContent(button);
        });
      });

      // Add event listeners to back buttons
      backButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          this.hideCardContent(button);
        });
      });
    }

    showCardContent(button) {
      // Find the closest card wrapper
      const cardWrapper = button.closest('.card-wrapper');
      if (!cardWrapper) return;

      // Find the card content wrapper and the parent li element
      const contentWrapper = cardWrapper.querySelector('.card__content-wrapper');
      const parentLi = cardWrapper.closest('li');

      if (contentWrapper && parentLi) {
        // Show the content wrapper
        contentWrapper.style.display = 'block';
        contentWrapper.style.opacity = '1';
        
        // Add 'open' class to the li element
        parentLi.classList.add('open');
      }
    }

    hideCardContent(button) {
      // Find the closest card wrapper
      const cardWrapper = button.closest('.card-wrapper');
      if (!cardWrapper) return;

      // Find the card content wrapper and the parent li element
      const contentWrapper = cardWrapper.querySelector('.card__content-wrapper');
      const parentLi = cardWrapper.closest('li');

      if (contentWrapper && parentLi) {
        // Hide the content wrapper
        contentWrapper.style.display = 'none';
        contentWrapper.style.opacity = '0';
        
        // Remove 'open' class from the li element
        parentLi.classList.remove('open');
      }
    }
  }

  // Initialize the functionality when DOM is loaded
  document.addEventListener('DOMContentLoaded', function() {
    initializeCardInteractions();
  });

  // Also handle dynamically loaded content (for AJAX/filter updates)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if the added node itself is a card wrapper
            if (node.classList && node.classList.contains('card-wrapper')) {
              initializeCardWrapper(node);
            }
            
            // Check for card wrappers within the added node
            const cardWrappers = node.querySelectorAll ? node.querySelectorAll('.card-wrapper') : [];
            cardWrappers.forEach(cardWrapper => {
              initializeCardWrapper(cardWrapper);
            });
          }
        });
      }
    });
  });

  // Start observing the document for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Function to initialize card interactions
  function initializeCardInteractions() {
    const cardWrappers = document.querySelectorAll('.card-wrapper');
    cardWrappers.forEach(cardWrapper => {
      initializeCardWrapper(cardWrapper);
    });
  }

  // Function to initialize a single card wrapper
  function initializeCardWrapper(cardWrapper) {
    // Check if the card wrapper already has the interactions initialized
    if (!cardWrapper.hasAttribute('data-interactions-initialized')) {
      // Create a new instance for each card wrapper
      new CardProductInteractions(cardWrapper);
      
      // Mark as initialized
      cardWrapper.setAttribute('data-interactions-initialized', 'true');
    }
  }
})();
